import { render } from "./bell.vue?vue&type=template&id=2e65d808"
import script from "./bell.vue?vue&type=script&lang=js"
export * from "./bell.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__